import '../scss/app.scss';
import './vendor/off-canvas.js';
import FormController from './Controllers/FormController';

document.addEventListener("DOMContentLoaded", () => {
	let formPage = new FormController();
});